<ion-header class="ion-no-border page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div  (click)="goHome()" class="header-logo">&nbsp;</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="showMenu()" class="menu" [attr.aria-label]="'ARIA.MENU.BUTTON.LABEL_0' | translate">
        <ion-icon slot="icon-only" aria-hidden="true"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="page-title" translate>CONTENT.CERTIFICATES.TITLE</div>

</ion-header>

<ion-content class="ion-padding" no-bounce>

  <ng-template [ngIf]="isLoading">
    <div class="v-box full-width full-height justify-around align-center">
      <ion-spinner color="dark"></ion-spinner>
    </div>
  </ng-template>
  <ng-template [ngIf]="!isLoading && !hasCertificates">
    <div class="no-entries-label" translate>CONTENT.CERTIFICATES.NO_ENTRIES</div>
  </ng-template>

  <ng-template [ngIf]="hasCertificates">
    <ion-grid>
      <ion-row>
        <ion-col *ngFor="let cmodule of cmodules" size="6" size-sm="6" size-md="6">
          <div class="leada-certificate">
            <ion-icon name="ribbon-outline"></ion-icon>
            <div>
              {{getLocalizedText(cmodule.title)}}
            </div>
            <div>
              {{getLocalizedDate(cmodule.doneDate)}}
            </div>
            <ion-button fill="solid" shape="round" expand="block" color="light" text-wrap class="full-width ion-text-wrap" translate (click)="getPdfCModule(cmodule, $event)">
              CMODULE.BUTTON.PDF
            </ion-button>
          </div>
        </ion-col>
        <ion-col *ngFor="let certificate of certificates" size="6" size-sm="6" size-md="6">
          <div class="leada-certificate">
            <ion-icon name="trophy-outline"></ion-icon>
            <div>
              {{getLocalizedText(certificate.contentFull.title)}}
            </div>
            <div>
              {{getLocalizedDate(certificate.doneDate)}}
            </div>
            <ion-button fill="solid" shape="round" expand="block" color="light" text-wrap class="full-width ion-text-wrap" translate (click)="getPdf(certificate, $event)">
              CONTENT.BUTTON.PDF
            </ion-button>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-template>

</ion-content>
